import { useFormContext } from 'react-hook-form';

/**
 * Type-safe form context hook that infers types from the Zod schema.
 *
 * This hook provides access to the form context with full TypeScript type inference
 * based on the Zod schema used in the parent Form component.
 *
 * @template T - The Zod schema type used in the parent Form component
 * @returns Typed React Hook Form methods with inferred types from the schema
 *
 * @example
 * ```tsx
 * const schema = z.object({
 *   email: z.string().email(),
 *   age: z.number().min(18)
 * });
 *
 * function MyForm() {
 *   return (
 *     <Form schema={schema} onSubmit={(data) => console.log(data)}>
 *       <MyField />
 *     </Form>
 *   );
 * }
 *
 * function MyField() {
 *   const form = useFormContextTyped<typeof schema>();
 *   // form.watch('email') is type-safe and autocompletes
 *   // form.watch('age') is also type-safe
 *   // form.watch('invalid') would be a TypeScript error
 * }
 * ```
 */
function useFormContextTyped() {
    return useFormContext();
}

export { useFormContextTyped };
//# sourceMappingURL=FormContext.js.map
